import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsPostDischargeTabPostDischargeStatus from '../../form-fields-post-discharge-tabs/tab-post-discharge/tab-post-discharge';
// import FormFieldsPostDischargeTabPostDischargeStatus from '../../form-fields-post-discharge-tabs/tab-post-discharge/tab-post-discharge-hooks';
class EditViewPostDischargeTabOutcome extends Component {
  render() {
    return (
      <div>
        <FormFieldsPostDischargeTabPostDischargeStatus
          {...this.props}
          locked={this.props.locked}

          postdischargecontactdate90dSelected={this.props.postdischargecontactdate90dSelected}
          postdischargecontactdate180dSelected={this.props.postdischargecontactdate180dSelected}
          postdischargecontactdate12mSelected={this.props.postdischargecontactdate12mSelected}
          postdischargecontactdate24mSelected={this.props.postdischargecontactdate24mSelected}
        />
      </div>
    );
  }
}
EditViewPostDischargeTabOutcome.propTypes = {
  locked: PropTypes.bool,

  postdischargecontactdate90dSelected: PropTypes.string,
  postdischargecontactdate180dSelected: PropTypes.string,
  postdischargecontactdate12mSelected: PropTypes.string,
  postdischargecontactdate24mSelected: PropTypes.string,
}
EditViewPostDischargeTabOutcome = reduxForm({
  form: 'PostDischargeEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewPostDischargeTabOutcome);
export default EditViewPostDischargeTabOutcome;